export const uiConfig = {
  appLogo: '/aave-com-logo-header.svg',
  cp0xLogo: '/cp0x_logo.svg',
};
